<div class="undersøkelse">
  <button mat-icon-button type="button" (click)="visSkjulResultater()" class="mat-medium-icon-button" data-testid="ekspander">
    @if (visResultater()) {
      <mat-icon>keyboard_arrow_up</mat-icon>
    } @else {
      <mat-icon>keyboard_arrow_down</mat-icon>
    }
  </button>
  <c3-todelt-pai [totalt]="undersoekelse().antallRespondenter" [andel]="undersoekelse().antallRespondenterSvart" visningstype="donut" bredde="30"
                 matTooltip="{{ '{antallSvar} av {antallRespondenter} har svart' | translate:{antallSvar:undersoekelse().antallRespondenterSvart, antallRespondenter:undersoekelse().antallRespondenter} }}"/>
  <span class="tittel" (click)="visSkjulResultater()">
    <div data-testid="tittel">{{ undersoekelse().tittel }}</div>
    <div class="sub-tittel">
      @if (undersoekelse().erAapenForRespons) {
        {{ 'Svarfrist {dato}'|translate:{dato: undersoekelse().responsperiode!.slutt|zoneddatetimeSomPlaindate|plaindate} }}.
      } @else if (undersoekelse().erAvsluttet) {
        {{ 'Gjennomført {dato}'|translate:{dato: (undersoekelse().responsperiode!.start|zoneddatetimeSomPlaindate|plaindate:{year: 'numeric', month: 'short'})} }}.
      } @else {
        {{ 'Undersøkelsen har ikke blitt aktivert'|translate }}.
      }
      {{ 'Benytter skjemaet "{tittel}"'|translate: {tittel: undersoekelse().skjemaTittel} }}
    </div>

  </span>
  @if (undersoekelse().erAapenForRespons && undersoekelse().kallendeBrukersRespondentId != null) {
    <button mat-stroked-button color="primary" type="button" (click)="besvar()">
      {{ "Svar på spørreundersøkelsen" | translate }}
    </button>
  }
  @if (!undersoekelse().erAapenForRespons && !undersoekelse().erAvsluttet && brukerKanRedigere()) {
    <button mat-stroked-button color="primary" type="button" (click)="aapne()">
      {{ "Åpne for besvarelser" | translate }}
    </button>
  }
  @if (undersoekelse().erAapenForRespons && brukerKanRedigere()) {
    <button mat-stroked-button color="primary" type="button" (click)="steng()">
      {{ "Avslutt spørreundersøkelsen" | translate }}
    </button>
  }
  <button mat-icon-button [matMenuTriggerFor]="undersoekelseMeny" (click)="$event.stopPropagation()" class="mat-medium-icon-button" aria-label="Meny" data-testid="meny-knapp">
    <mat-icon class="material-symbols-fet">more_vert</mat-icon>
  </button>
  <mat-menu #undersoekelseMeny="matMenu" aria-label="{{'Meny'|translate}}">
    <button mat-menu-item (click)="visSkjema()">
      <mat-icon>content_paste_search</mat-icon>
      <span>{{ "Vis spørreskjema" | translate }}</span>
    </button>
    <button mat-menu-item (click)="aapneResultatrapport()">
      <mat-icon fontSet="lederplan-ikon-pdf" class="mat-icon--lederplan-ikon"/>
      <span>{{ "Åpne resultatrapport" | translate }}</span>
    </button>
    <mat-divider/>
    @if (brukerKanRedigere()) {
      @if (undersoekelse().erAapenForRespons) {
        <button mat-menu-item (click)="steng()">
          <mat-icon>stop_circle</mat-icon>
          <span>{{ "Avslutt spørreundersøkelsen" | translate }}</span>
        </button>
      } @else {
        <button mat-menu-item (click)="aapne()">
          <mat-icon>play_circle</mat-icon>
          <span>{{ "Åpne for besvarelser" | translate }}</span>
        </button>
      }
      <button mat-menu-item (click)="rediger()" [disabled]="undersoekelse().antallRespondenterSvart > 0"
              [matTooltip]="undersoekelse().antallRespondenterSvart > 0 ? ('Minst én respondent har besvart spørreundersøkelsen, den kan derfor ikke redigeres'|translate) :'' "
              matTooltipPosition="left">
        <mat-icon>edit</mat-icon>
        <span>{{ "Rediger" | translate }}</span>
      </button>
      <!-- på sikt bør dette innslaget fjernes -->
      @if (undersoekelse().erAvsluttet && brukerHarKiFeature()) {
        <button mat-menu-item (click)="genererAnalyseDebug()" data-testid="generer-analyse-debug">
          <mat-icon>psychology</mat-icon>
          <span>Test analyseprompt (debug)</span>
        </button>
      }
      <mat-divider/>
      <button mat-menu-item (click)="slett()">
        <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
        <span>{{ "Slett" | translate }}</span>
      </button>
    }
  </mat-menu>
</div>

@if (visResultater()) {
  <div class="detaljer">
    @if (!undersoekelse().erAapenForRespons && !undersoekelse().erAvsluttet) {
      <tips>
        {{ 'Ingen data har blitt samlet inn'|translate }}, <a (click)="aapne()">{{ 'åpne for besvarelse'|translate }}</a> {{ 'for å sende invitasjon til respondenter'|translate }}
      </tips>
    } @else if (undersoekelse().erAapenForRespons) {
      <tips>
        {{ 'Resultater kan ikke vises før undersøkelsen er avsluttet'|translate }}
      </tips>
    } @else if (resultater() != null) {
      @if (resultater()!.analyse != null) {
        <div class="resultat-kontainer analyse" data-testid="analyse">
          <div class="analyse-overskrift">
            <h1>{{ 'Analyse'|translate }}</h1>
            @if (brukerKanRedigere() && !redigererAnalyse()) {
              <button mat-icon-button type="button" (click)="redigerAnalyse()" class="mat-medium-icon-button"
                      [attr.aria-label]="'Rediger analysen'|translate" matTooltip="{{ 'Rediger analysen'|translate }}" data-testid="rediger-analyse">
                <mat-icon>edit</mat-icon>
              </button>
            }
          </div>
          <tips>{{ 'Analysen er generert av kunstig intelligens (KI) og kan inneholde feil'|translate }}.</tips>
          @if (redigererAnalyse()) {
            <mat-form-field>
              <mat-label>{{ 'Analyse'|translate }}</mat-label>
              <riktekst-redigering [skjemakontroll]="analyseSkjemakontroll" [gruppeId]="undersoekelse().eiendeGruppeId" innholdBrukesIPdf="true" data-testid="analyse-felt"/>
            </mat-form-field>
            <div class="analyse-knapper">
              <button mat-button type="button" (click)="avbrytRedigeringAvAnalyse()" [disabled]="lagrerAnalyse()">{{ 'Avbryt'|translate }}</button>
              <button mat-raised-button color="primary" type="button" (click)="lagreAnalyse()" [disabled]="lagrerAnalyse()"
                      [visSpinner]="lagrerAnalyse()" spinnerTekst="{{'Lagrer...'|translate}}" data-testid="lagre-analyse">
                {{ 'Lagre'|translate }}
              </button>
            </div>
          } @else {
            <html-formatert [innhold]="resultater()!.analyse!"/>
          }
        </div>
      } @else if (brukerKanRedigere() && undersoekelse().antallRespondenterSvart > 0 && brukerHarKiFeature()) {
        <div class="resultat-kontainer analyse ingen-analyse" data-testid="ingen-analyse">
          <p>{{ 'Kunstig intelligens (KI) kan lage en skriftlig analyse av resultatet av spørreundersøkelsen'|translate }}.</p>
          <button mat-stroked-button color="primary" type="button" (click)="genererAnalyse()" [disabled]="generererAnalyse()"
                  [visSpinner]="generererAnalyse()" spinnerTekst="{{'Genererer analyse...'|translate}}" data-testid="generer-analyse">
            {{ 'Generer analyse'|translate }}
          </button>
        </div>
      }
      <div class="resultat-kontainer">
        <spoerreundersoekelse-korellert-resultatliste [resultater]="resultater()"/>
      </div>
    } @else {
      <div class="resultat-kontainer">
        <laster-data>{{ 'Laster...'|translate }}</laster-data>
      </div>
    }
    @if (behandlinger() != null) {
      @if (antallBehandlinger() > 0) {
        <ng-container *ngTemplateOutlet="visBehandlingerTemplate"/>
      } @else {
        <p>{{ 'Vil du behandle rapporten i et møte?'|translate }}</p>
        @if (brukerKanRedigere()) {
          <tips>
            {{ 'Bruk "Nytt dokument"-funksjonen på møtesak for å importere rapporten'|translate }}.
            <a (click)="aapneHjelpetekstForBehandleSpoerreundersoekelse()">{{'Se her i Hjelpesenteret'|translate}}.</a>
          </tips>
        }
      }
    }

  </div>
}

<!--dialog som viser skjemaet knyttet til undersøkelsen -->
<ng-template #visBehandlingerTemplate>
  <p>{{ 'Spørreundersøkelsen er til behandling i følgende sak'|translate }}:</p>
  <ul>
    @for (sak of behandlinger()!; track sak.id) {
      <li>
        <a (click)="gaaTilSak(sak)">
          {{ "Sak {sakstittel} i {moetetittel} {moetedato}"|translate : {sakstittel: sak.tittel, moetetittel: sak.moete.tittel, moetedato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate} }}
        </a>
      </li>
    }
  </ul>
</ng-template>


<!--dialog som viser skjemaet knyttet til undersøkelsen -->
<ng-template #visSkjemaDialogTemplate>
  <div class="vis-skjema-dialog" data-testid="vis-skjema-dialog">
    <h2 mat-dialog-title>{{ 'Forhåndsvisning av "{tittel}"'|translate:{tittel: skjema().tittel} }}</h2>
    <mat-dialog-content>
      @if (skjemaSomUndersoekelse() != null) {
        <spoerreundersoekelse-besvarelse-skjema [skjemakontroll]="skjemaSomUndersoekelse()!"/>
      } @else {
        <laster-data>{{ 'Laster spørreundersøkelsen'|translate }}</laster-data>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ "Lukk"|translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<!--dialog for åpning av undersøkelsen -->
<ng-template #aapneUndersoekelseDialogTemplate>
  <form [formGroup]="aapneUndersoekelseSkjema" (ngSubmit)="utfoerAapne()" class="åpne-undersøkelse-dialog" data-testid="åpne-undersøkelse-dialog">
    <h2 mat-dialog-title>{{ 'Åpne for besvarelse av spørreundersøkelsen'|translate }}</h2>
    <mat-dialog-content>
      <p>
        {{ "Åpne for besvarelse av spørreundersøkelsen" | translate:{tittel: undersoekelse().tittel} }}
        <span class="tittel">{{ undersoekelse().tittel }}</span>
      </p>
      <spoerreundersoekelse-invitasjon-skjema [skjemakontroll]="aapneUndersoekelseSkjema" [antallRespondenter]="undersoekelse().antallRespondenter"/>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button [mat-dialog-close]="true">{{ "Avbryt"|translate }}</button>
      <submit-button [skjema]="aapneUndersoekelseSkjema" [arbeidPaagaar]="laster()" spinnerTekst="{{'Åpner...'|translate}}">
        {{ "Åpne for besvarelse"|translate }}
      </submit-button>
    </mat-dialog-actions>
  </form>
</ng-template>

<!--dialog for stenging av undersøkelsen -->
<ng-template #stengUndersoekelseDialogTemplate>
  <form [formGroup]="stengUndersoekelseSkjema" (ngSubmit)="utfoerSteng()" class="steng-undersøkelse-dialog" data-testid="steng-undersøkelse-dialog">
    <h2 mat-dialog-title>{{ "Avslutt spørreundersøkelsen"|translate }}</h2>
    <mat-dialog-content>
      <p>
        {{ "Avslutt spørreundersøkelsen" | translate:{tittel: undersoekelse().tittel, antall: undersoekelse().antallRespondenter} }}
        <span class="tittel">{{ undersoekelse().tittel }}</span>.
      </p>
      <p>{{ "{antall} av totalt {totalt} respondenter har besvart spørreundersøkelsen."|translate:{antall: undersoekelse().antallRespondenterSvart, totalt: undersoekelse().antallRespondenter} }}</p>
      <tips>{{ "Når spørreundersøkelsen har blitt avsluttet kan respondenter ikke lenger besvare den (du kan fortsatt gjenåpne den)" | translate }}</tips>
      <fieldset>
        <mat-slide-toggle [formControl]="stengUndersoekelseSkjema.controls.informer"
                          matTooltip="{{'Dersom valgt sendes e-post til alle respondenter med informasjon at spørreundersøkelsen er avsluttet' | translate}}">
          {{ "Informer {antall} respondenter" | translate:{antall: undersoekelse().antallRespondenter} }}
        </mat-slide-toggle>
        @if (stengUndersoekelseSkjema.value.informer) {
          <mat-form-field>
            <mat-label>{{ "Melding inkludert i e-post til respondentene"|translate }}</mat-label>
            <riktekst-redigering [skjemakontroll]="stengUndersoekelseSkjema.controls.beskjed"/>
          </mat-form-field>
        }
      </fieldset>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button [mat-dialog-close]="true">{{ "Avbryt"|translate }}</button>
      <submit-button [skjema]="stengUndersoekelseSkjema" [arbeidPaagaar]="laster()" spinnerTekst="{{'Stenger...'|translate}}">
        {{ "Steng for besvarelse"|translate }}
      </submit-button>
    </mat-dialog-actions>
  </form>
</ng-template>

<!--dialog for sletting av undersøkelsen -->
<ng-template #slettUndersoekelseDialogTemplate>
  <div class="slett-undersøkelse-dialog" data-testid="slett-undersøkelse-dialog">
    <h2 mat-dialog-title>{{ 'Slett spørreundersøkelsen "{tittel}"'|translate:{tittel: undersoekelse().tittel} }}</h2>
    <mat-dialog-content>
      @if (this.antallBehandlinger() > 0) {
        <inline-melding type="advarsel">
          {{ 'Undersøkelsen kan ikke slettes da den er til behandling i {antall} saker'|translate:{antall: antallBehandlinger()} }}
        </inline-melding>
        <ng-container *ngTemplateOutlet="visBehandlingerTemplate"/>
      } @else {
        <p>{{ 'Handlingen kan ikke angres.'|translate:{tittel: undersoekelse().tittel} }}</p>
        @if (undersoekelse().erAapenForRespons) {
          <p>{{ 'Siden spørreundersøkelsen er åpen for besvarelse vil det bli sendt melding til respondentene om at den ikke lenger kan besvares.'|translate }}</p>
        }
        @if (undersoekelse().antallRespondenterSvart > 0) {
          <div class="melding-kontainer">
            <inline-melding type="advarsel">
              {{ '{antallSvar} besvarelser vil også bli slettet'|translate:{antallSvar: undersoekelse().antallRespondenterSvart} }}
            </inline-melding>
          </div>
        }
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button [mat-dialog-close]="true">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="warn" (click)="utfoerSlett()" [disabled]="laster() || this.antallBehandlinger() > 0" [visSpinner]="laster()" spinnerTekst="{{'Sletter...'|translate}}">
        {{ 'Slett'|translate }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
